// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            "AIzaSyCdFPb9vVKXqwIK9UknvlO4xj3CRRNvVRI",
  authDomain:        "awos-2025.firebaseapp.com",
  projectId:         "awos-2025",
  storageBucket:     "awos-2025.firebasestorage.app",
  messagingSenderId: "597959466350",
  appId:             "1:597959466350:web:0c172b6e66b56dd17af57f"
};

const app = initializeApp(firebaseConfig);
export const auth    = getAuth(app);
export const db      = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
export const storage = getStorage(app);

// ── FCM Push Notifications ──
let messaging = null;
try { messaging = getMessaging(app); } catch (_) { /* not supported (e.g. Safari < 16) */ }

export async function requestNotificationPermission(uid) {
  if (!messaging || !uid) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
    const token = await getToken(messaging, {
      vapidKey: 'BEzZ3fO2Z0_9jIXDZGM3SjEG3zc8z0RtpxwyJ2KA8UU',
    });
    if (token) {
      await updateDoc(doc(db, 'users', uid), { fcmTokens: arrayUnion(token) });
    }
    return token;
  } catch (err) {
    console.warn('FCM token error:', err.message);
    return null;
  }
}

export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}

export default app;
